import { Component, ComponentRef,ViewChild,ViewContainerRef}   from '@angular/core';
import { AfterViewInit, OnInit, OnDestroy}          from '@angular/core';
import { OnChanges, SimpleChange, ComponentFactory} from '@angular/core';
import { DynamicData, DynamicTypeBuilder } from './dynamic-dps/type.builder';
import { DynamicTemplateBuilder } from './dynamic-dps/template.builder';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'data-protection',
    template: `
    <div #dynamicDataProtectionHolder></div>
    `,
})
export default class DataProtection implements AfterViewInit, OnChanges, OnDestroy, OnInit
{
    @ViewChild('dynamicDataProtectionHolder', {read: ViewContainerRef})
    protected dynamicComponentTarget: ViewContainerRef;
    protected componentRef: ComponentRef<DynamicData>;
    protected wasViewInitialized = false;

    // @Input Can be used if required.
    // Add an Input called entity to all the candidate components
    protected entity = {};

    constructor( protected typeBuilder: DynamicTypeBuilder,
                 protected templateBuilder: DynamicTemplateBuilder,
                public authService: AuthService) {
    }


    protected refreshContent(vcd: boolean = false){

        if (this.componentRef) {
            this.componentRef.destroy();
        }

        let template = this.templateBuilder.prepareTemplate('data-protection', this.entity, vcd);

        this.typeBuilder
            .createComponentFactory(template)
            .then((factory: ComponentFactory<DynamicData>) =>
            {
                this.componentRef = this
                    .dynamicComponentTarget
                    .createComponent(factory);
                let component = this.componentRef.instance;

                component.entity = this.entity;
            });
    }

    public ngOnInit(): void {
        console.log('Dynamic On Init of DataProtection');
    }

    public ngAfterViewInit(): void {
        this.wasViewInitialized = true;
        this.refreshContent((this.authService.VREALM_TYPE === 'vcd'));
    }

    public ngOnChanges(changes: {[key: string]: SimpleChange}): void
    {
        if (this.wasViewInitialized) {
            return;
        }
        this.refreshContent();
    }

    public ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection.component.ts